module.exports = __webpack_public_path__ + "img/whiteBallone.1690485b.png";